export enum ConciergeAppointmentQuestionFlow {
  'TestDriveAppointment' = 'TestDriveAppointment',
  'FreeAppointment' = 'FreeAppointment',
  'AdviserSelectionAppointment' = 'AdviserSelectionAppointment'
}
